import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=275263e1&scoped=true&"
import script from "./InfoTab.vue?vue&type=script&lang=js&"
export * from "./InfoTab.vue?vue&type=script&lang=js&"
import style0 from "./InfoTab.vue?vue&type=style&index=0&id=275263e1&prod&lang=less&scoped=true&"
import style1 from "./InfoTab.vue?vue&type=style&index=1&id=275263e1&prod&lang=scss&"
import style2 from "./InfoTab.vue?vue&type=style&index=2&id=275263e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275263e1",
  null
  
)

export default component.exports